/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseActionLinksFragment, ActionLinksFragment, FullActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links';

/**
 * Get a single ActionLinks by ID (base - scalars only)
 */
export const getBaseActionLinksById = gql`
  ${BaseActionLinksFragment}

  query GetBaseActionLinksById($id: String!, $locale: String!, $preview: Boolean) {
    actionLinks(id: $id, locale: $locale, preview: $preview) {
      ...BaseActionLinksFragment
    }
  }
`;

/**
 * Get a single ActionLinks by ID (standard - 1 level deep)
 */
export const getActionLinksById = gql`
  ${ActionLinksFragment}

  query GetActionLinksById($id: String!, $locale: String!, $preview: Boolean) {
    actionLinks(id: $id, locale: $locale, preview: $preview) {
      ...ActionLinksFragment
    }
  }
`;

/**
 * Get a single ActionLinks by ID (full - 2 levels deep)
 */
export const getFullActionLinksById = gql`
  ${FullActionLinksFragment}

  query GetFullActionLinksById($id: String!, $locale: String!, $preview: Boolean) {
    actionLinks(id: $id, locale: $locale, preview: $preview) {
      ...FullActionLinksFragment
    }
  }
`;

/**
 * Get all ActionLinks entries with pagination (base - scalars only)
 */
export const getBaseActionLinkss = gql`
  ${BaseActionLinksFragment}

  query GetBaseActionLinkss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ActionLinksOrder]
    $where: ActionLinksFilter
    $preview: Boolean
  ) {
    actionLinksCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseActionLinksFragment
      }
    }
  }
`;

/**
 * Get all ActionLinks entries with pagination (standard - 1 level deep)
 */
export const getActionLinkss = gql`
  ${ActionLinksFragment}

  query GetActionLinkss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ActionLinksOrder]
    $where: ActionLinksFilter
    $preview: Boolean
  ) {
    actionLinksCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ActionLinksFragment
      }
    }
  }
`;

/**
 * Get all ActionLinks entries with pagination (full - 2 levels deep)
 */
export const getFullActionLinkss = gql`
  ${FullActionLinksFragment}

  query GetFullActionLinkss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ActionLinksOrder]
    $where: ActionLinksFilter
    $preview: Boolean
  ) {
    actionLinksCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullActionLinksFragment
      }
    }
  }
`;
